import { CONTENT_TYPES } from 'lib/const';
import {
  DELETE_CONTENT_OR_FOLDER_SUCCESS,
  FAVORITE_CONTENT_FULFILLED,
  GET_USER_REQUEST_FULFILLED,
  GET_USER_REQUEST_REJECTED,
  SEARCH_MOST_RECENT_COMPONENTS_FULFILLED,
  SEARCH_MOST_RECENT_COMPONENTS_REJECTED
} from './const';

export const defaultState = {};

/**
 * a reducer
 * @param {object} state - the current state
 * @param {object} action - the action causing a state change
 * @returns {object} the next state
 */
export const userReducer = function user(state = defaultState, action = null) {
  if (!action) {
    return state;
  }
  switch (action.type) {
    case DELETE_CONTENT_OR_FOLDER_SUCCESS: {
      const favoritesData = state.favorites || {};
      let filteredFavorites;
      let newFavorites;
      if (action.context === CONTENT_TYPES.COMPONENT) {
        const favoriteComponents = favoritesData.components || [];
        filteredFavorites = favoriteComponents.filter(child => child.Id !== action.contentId);
        newFavorites = { ...favoritesData, components: filteredFavorites };
      } else if (action.context === CONTENT_TYPES.PAGE) {
        const favoritePages = favoritesData.pages || [];
        filteredFavorites = favoritePages.filter(child => child.Id !== action.contentId);
        newFavorites = { ...favoritesData, pages: filteredFavorites };
      } else {
        const favoriteFolders = favoritesData.folders || [];
        filteredFavorites = favoriteFolders.filter(child => child.Id !== action.contentId);
        newFavorites = { ...favoritesData, folders: filteredFavorites };
      }
      const mostRecentComps = state.mostRecentComponents || [];
      const filteredRecentComponents = mostRecentComps.filter(
        child => child.Id !== action.contentId
      );
      return {
        ...state,
        favorites: newFavorites,
        mostRecentComponents: filteredRecentComponents
      };
    }
    case GET_USER_REQUEST_FULFILLED: {
      return {
        ...state,
        ...action.payload
      };
    }
    case GET_USER_REQUEST_REJECTED:
      console.warn(`getUser request failed with error (${action.error})`);
      return state;
    case SEARCH_MOST_RECENT_COMPONENTS_FULFILLED:
      return {
        ...state,
        mostRecentComponents: action.response
      };
    case SEARCH_MOST_RECENT_COMPONENTS_REJECTED:
      console.warn(`get most recent request failed with error (${action.error})`);
      return state;
    case FAVORITE_CONTENT_FULFILLED:
      return {
        ...state,
        favorites: {
          ...state.favorites,
          ...action.favorites
        }
      };
    default:
      return state;
  }
};
